(function($) {

	// Wait for document to get ready.
	$(document).ready(function() {
		if (document.querySelector('body').classList.contains('woocommerce-page')) {
			return
		}

		//
		var getTableHeadColumns = function(tableElement) {
			//
			var $table = $(tableElement);

			var thInFirstRow = $table.find('tr:first-of-type th');

			return thInFirstRow;

			// //
			// if(thInFirstRow.length) {
			// 	return thInFirstRow;
			// }
			//
			// var tdInFirstRow = $table.find('tr:first-of-type td');
			//
			// //
			// if(tdInFirstRow.length) {
			// 	return tdInFirstRow;
			// }
		};

		//
		var table2list = function(tableElement) {
			//
			var $table = $(tableElement);

			//
			var headColumns = getTableHeadColumns(tableElement);

			//
			if(!headColumns.length) {
				return;
			}

			//
			var tableRows = $table.find('tr');

			if(!tableRows.length) {
				return;
			}

			if(tableRows.length < 2) {
				return;
			}

			if($table.hasClass("hidden") || $table.parents(".hidden").length) {
				return;
			}

			//
			$table.addClass("has-list-version");

			//
			var listElement = document.createElement('ul');
			listElement.className = "table-list";

			//
			tableRows.each(function(rowIndex, tableRow) {
				//
				if(rowIndex !== 0) {

					var $tableRow = $(tableRow);

					var listItem = document.createElement('li');

					var columns = $tableRow.find('td');

					var dl = document.createElement('dl');
					dl.className = "inline";

					columns.each(function(columnIndex, column) {
						if(headColumns[columnIndex] && headColumns[columnIndex].innerHTML) {
							$(dl).append("<dt>" + headColumns[columnIndex].innerHTML + ": </dt>");
						} else {
							$(dl).append("<dt></dt>");
						}

						$(dl).append("<dd>" + column.innerHTML + "</dd>");
					});

					$(listItem).append(dl);

					$(listElement).append(listItem);
				}
			});

			//
			$table.after(listElement);
		};

		var tables = $('table');

		tables.each(function(tableIndex, table) {

			var $table = $(table);

			if ($table.hasClass('variations')) {
				return
			}

			//
			if(!$table.hasClass('has-list-version')) {

				table2list(tables[tableIndex]);
			}
		});

		//
		// Create a mutation observer.
		var newTableObserver = new MutationObserver(function (mutations) {

			// Loop over mutations.
			mutations.forEach(function(mutation) {

				// If nodes where added.
				if(mutation.addedNodes) {
					// Loop over each added node.
					for(var elementIndex in mutation.addedNodes) {
						//
						if(!mutation.addedNodes.hasOwnProperty(elementIndex)) {
							continue;
						}

						//
						var element = mutation.addedNodes[elementIndex];
						var $element = $(element);

						//
						if(element.tagName === "TABLE") {
							table2list(element);
						} else {
							var tables = $element.find('table');

							tables.each(function(tableIndex, table) {
								table2list(table)
							});
						}
					}
				}
			});
		});

		var config = {
			subtree: true,
			childList: true
		};

		$('softadmin-snippet').each(function(snippetIndex, snippet) {
			// Start observing.
			newTableObserver.observe(snippet, config);
		});

	});
})(window.jQuery);
